<template>
  <div class="wrapper">
    <label v-if="label !== ''" :class="{'texto-vermelho' : labelVermelhoLocal}">
      {{ label }}
    </label>

    <b-input-group :class="{ 'cec-pill-group': arredondado }">
      <autocomplete
        :source="uri"
        :placeholder="place"
        :input-class-required="classeRequired"
        results-display="CODIGONOME"
        results-value="ID"
        :disableInput="desabilitarInput"
        :input-class="arredondado ? 'cec-pill-left' : ''"
        @input="setId"
        @indexChanged="escutaAlteracaoDeValor"
        @selected="onSelecionado"
        @clear="onClear"
        ref="auto"
      />

      <b-input-group-append :class="{ 'cec-pill-append': arredondado }">
        <b-button
          v-if="exibirBloqueadoLocal === true"
          variant="warning"
          :class="arredondado ? 'cec-pill-mid shadow-xs px-3' : ''"
          @click.stop.prevent="abrirModalDebitos()"
        >
          <i class="fa fa-eye"></i>
        </b-button>

        <b-button
          v-if="!desabilitarInput"
          :disabled="desabilitarInput"
          v-b-modal="idModal"
          variant="soft-primary"
          :class="arredondado ? 'cec-pill-right shadow-xs px-3' : ''"
        >
          <i class="fa fa-list"></i>
        </b-button>
      </b-input-group-append>
    </b-input-group>


    <!-- Modal de pesquisa manual -->
    <b-modal
      :id="idModal"
      :ref="idModal"
      hide-header
      hide-footer
      centered
      size="xl"
      body-class="p-0 overflow-hidden"
      content-class="border-0 shadow-lg"
      @shown="clearModal"
    >
      <div class="modal-header-premium p-3 d-flex align-items-center bg-primary">
          <div class="header-icon-wrapper mr-3" style="background: rgba(255,255,255,0.1)">
              <i class="fa fa-search text-white"></i>
          </div>
          <div>
              <h5 class="mb-0 font-weight-bold text-white">Pesquisar Clientes</h5>
              <small class="text-white opacity-75">Busque por nome, ID ou outros filtros</small>
          </div>
          <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs[idModal].hide()">
              <i class="fa fa-times fa-lg"></i>
          </b-button>
      </div>

      <div class="p-4 bg-white">
        <form @submit.stop.prevent="handleSubmit">
          <b-overlay :show="isLoading" rounded="sm">
            <div class="card card-filter-premium p-4 border-0 shadow-sm mb-4">
              <b-row align-v="end">
                <b-col sm="8">
                  <label class="font-weight-bold text-muted small">Nome do Cliente</label>
                  <b-form-input
                    type="text"
                    id="nome"
                    ref="edNomePesquisa"
                    placeholder="Informe o Nome"
                    v-model="pesquisa.nome"
                    class="custom-input-premium rounded-pill"
                  />
                </b-col>
                <b-col sm="4" class="d-flex gap-2">
                  <b-button type="submit" variant="primary" pill class="px-4 font-weight-bold shadow-sm mr-2" @click.stop.prevent="onSubmit">
                    <i class="fa fa-search mr-1"></i> Pesquisar
                  </b-button>
                  <b-button type="button" variant="soft-danger" pill class="px-3" @click.stop.prevent="clearModal">
                    <i class="fa fa-ban mr-1"></i> Limpar
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-overlay>
        </form>
      

        <b-row v-if="items && items.length > 0">
          <b-col sm="12">
            <b-table
              class="table table-sm"
              striped
              hover
              stacked="md"
              responsive
              :busy.sync="isBusy"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @row-clicked="selecionar"
            >
              <template #cell(ID)="item">{{ item.item.ID }}</template>
              <template #cell(OP_SITUACAO_FINANCEIRO)="item">
                <b-badge :variant="colorirSituacao(item.item)">{{
                  traduzirSituacao(item.item)
                }}</b-badge>
              </template>
              <template #cell(NOME)="item">{{ item.item.NOME }}</template>
              <template #cell(RAZAOSOCIAL)="item">{{ item.item.RAZAOSOCIAL }}</template>
              <template #cell(ENDERECO)="item">{{ item.item.ENDERECO }}</template>
            <template #cell(BAIRRO)="item">{{ item.item.BAIRRO }}</template>
            </b-table>
            <div class="justify-content-center row my-1">
              <b-pagination
                size="md"
                :total-rows="items.length"
                :per-page="perPage"
                v-model="currentPage"
              />
            </div>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-end mt-3 pt-3 border-top">
             <b-button variant="outline-secondary" pill class="px-4" @click="$refs[idModal].hide()">Cancelar</b-button>
        </div>
      </div>
    </b-modal>

    <!-- MODAL DÉBITOS EM ABERTO -->
    <b-modal
      ref="modal-debitos"
      hide-header
      hide-footer
      centered
      size="xl"
      body-class="p-0 overflow-hidden"
      content-class="border-0 shadow-lg"
    >
      <div class="modal-header-premium p-3 d-flex align-items-center bg-warning">
          <div class="header-icon-wrapper mr-3" style="background: rgba(255,255,255,0.1)">
              <i class="fa fa-exclamation-circle text-white"></i>
          </div>
          <div>
              <h5 class="mb-0 font-weight-bold text-white">Débitos em Aberto</h5>
              <small class="text-white opacity-75">Resumo financeiro e pendências do cliente</small>
          </div>
          <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs['modal-debitos'].hide()">
              <i class="fa fa-times fa-lg"></i>
          </b-button>
      </div>

      <div class="p-4 bg-white">
        <!-- (mantido como no seu original) -->
        <b-row class="mb-4">
          <b-col md="12">
            <b-row>
              <b-col sm="6" v-if="debitos.CLIENTE_ID > 0">
                <div class="p-3 bg-light rounded shadow-xs">
                  <label class="font-weight-bold text-muted small px-1">Total em Dias R$:</label>
                  <vue-autonumeric
                    :disabled="true"
                    :options="'commaDecimalCharDotSeparator'"
                    v-model="debitos.totalEmDias"
                    class="form-control font-azul campo-total-moeda text-right negrito border-0 bg-transparent h4 mb-0"
                  />
                </div>
              </b-col>

              <b-col sm="6" v-if="debitos.CLIENTE_ID > 0">
                <div class="p-3 bg-soft-danger rounded shadow-xs" style="background-color: rgba(248, 108, 107, 0.1);">
                  <label class="font-weight-bold text-danger small px-1">Total Atrasados R$:</label>
                  <vue-autonumeric
                    :disabled="true"
                    :options="'commaDecimalCharDotSeparator'"
                    v-model="debitos.totalAtrasado"
                    class="form-control font-vermelha campo-total-moeda text-right negrito border-0 bg-transparent h4 mb-0"
                  />
                </div>
              </b-col>
            </b-row>

            <div class="mt-4">
              <b-table
                class="mb-0 table-outline"
                responsive="sm"
                hover
                :items="debitos.tableItems"
                :fields="debitos.tableFields"
                head-variant="light"
              >
                <template #cell(avatar)="">
                  <i class="fa fa-shopping-bag"></i>
                  <span class="avatar-status" :class="'info'"></span>
                </template>

                <template #cell(cliente)="cliente">
                  <div><strong>{{ cliente.item.cliente.nome }}</strong></div>
                  <div class="small text-muted">
                    <span>Documento: {{ cliente.item.cliente.documento }}</span>
                    <span>[{{ cliente.item.cliente.parcela }}]</span>
                  </div>
                  <div class="small text-muted">
                    <span>{{ cliente.item.cliente.itens }}</span>
                  </div>
                </template>

                <template #cell(valor)="linha">
                  <div class="clearfix">
                    <div class="float-left">
                      <strong>Original: {{ linha.item.valor.valorDocumento }}</strong>
                    </div>
                    <div class="float-right">
                      <small class="text-muted">{{ linha.item.valor.dataVencimento }} - </small>
                      <small :class="['text-muted', linha.item.valor.classe]">
                        {{ linha.item.valor.dataVencimento }}
                      </small>
                    </div>
                  </div>
                  <b-progress height class="progress-xs" v-model="linha.item.valor.percentual" :variant="variant(linha.item.valor)" />
                  <strong>Em Aberto: </strong>
                  <strong :class="linha.item.valor.classe">{{ linha.item.valor.valorAberto }}</strong>
                  <strong>({{ linha.item.valor.percentual }}%)</strong>
                </template>

                <template #cell(dias)="dias">
                  <div class="small text-muted">Último Pagamento</div>
                  <template v-if="dias.item.dias == '0'">
                    <strong>Sem Movimento</strong>
                  </template>
                  <template v-else>
                    <strong>{{ dias.item.dias }} Dias Atrás</strong>
                  </template>
                </template>
              </b-table>
            </div>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-center gap-3 mt-3 pt-3 border-top">
          <b-button type="button" variant="outline-secondary" pill class="px-4" @click="$refs['modal-debitos'].hide()">
            <i class="fa fa-arrow-left"></i> Voltar
          </b-button>
          <b-button type="button" variant="warning" pill class="px-4 text-white font-weight-bold" @click.stop.prevent="imprimir()">
            <i class="fa fa-print"></i> Imprimir
          </b-button>
        </div>
      </div>
    </b-modal>
    <!-- FIM MODAL DÉBITOS -->
  </div>
</template>

<script>
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import Autocomplete from '../componentes/Autocomplete'
import moment from 'moment'
import { Callout } from '../../components'
import Tools from '@/tools/tools.js'

export default {
  props: {
    label: { type: String, default: '' },
    place: String,
    labelBotao: String,
    idInicial: Number,
    classeRequired: Boolean,
    labelVermelho: Boolean,
    idModal: String,
    desabilitarInput: Boolean,
    layoutLinear: Boolean,
    tamanhoColunaLabel: String,
    tamanhoColunaAutocomplete: String,
    value: String,
    exibirBloqueado: Boolean,
    arredondado: { type: Boolean, default: false }
  },
  data () {
    return {
      exibirBloqueadoLocal: false,
      labelVermelhoLocal: false,
      idLocal: null, // guarda o ID atual do autocomplete
      resultado: '',
      pesquisa: { id: '', vendedorId: '', nome: '' },
      isLoading: false,
      status: '',
      isBusy: false,
      items: [],
      fields: [
        { key: 'CODIGO', label: 'Id', class: 'my-left-border my-left-right my-left-bottom', sortable: true },
        { key: 'OP_SITUACAO_FINANCEIRO', label: 'Situação', class: 'my-left-border my-left-right my-left-bottom', sortable: true },
        { key: 'RAZAOSOCIAL', label: 'Razao', class: 'my-left-border my-left-right my-left-bottom', sortable: true },
        { key: 'NOME', label: 'Nome', class: 'my-left-border my-left-right my-left-bottom', sortable: true },
        { key: 'ENDERECO', label: 'Endereço', class: 'my-left-border my-left-right my-left-bottom', sortable: true },
        { key: 'BAIRRO', label: 'Bairro', class: 'my-left-border my-left-right my-left-bottom', sortable: true },
        { key: 'CIDADE', label: 'cidade', class: 'my-left-border my-left-right my-left-bottom', sortable: true },
        { key: 'NOTAS_ABERTO', label: 'Notas', class: 'my-left-border my-left-right my-left-bottom', sortable: true },
        { key: 'VL_ABERTO', label: 'Valor R$', class: 'my-left-border my-left-right my-left-bottom', sortable: true,
          formatter: (value) => value ? value.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 3 }) : 0.00 }
      ],
      currentPage: 1,
      perPage: 100,
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      uri: this.uriComplete(),
      debitos: {
        totalTitulos: 0,
        totalEmDias: 0,
        totalAtrasado: 0,
        quantTitulos: 0,
        registro: { CLIENTE_ID: null },
        parametros: { nomeCliente: '' },
        tableItems: [],
        tableFields: [
          { key: 'avatar', label: '', sortable: true },
          { key: 'cliente', label: 'Cliente', sortable: true },
          { key: 'valor', label: 'Resumos', sortable: true },
          { key: 'dias', label: 'Valor', sortable: true }
        ]
      }
    }
  },
  components: { VueButtonSpinner, Autocomplete, Callout, moment },
  computed: {
    labelVermelhoValue () { return this.labelVermelho },
    exibirBotaoValue () { return this.exibirBloqueado }
  },
  methods: {
    uriComplete () {
      // mantém seu comportamento atual, aplicando vendedorId quando existir
      const base = this.$http.defaults.baseURL
      const vend = window.localStorage.getItem('vendedorId')
      if (!vend || vend === '' || vend === '100') {
        return base.concat('api/protected/cliente/autocomplete?&texto=')
      }
      return base.concat(`api/protected/cliente/autocomplete?vendedorId=${vend}&texto=`)
    },

    // ------ Eventos para o pai (NF)
    setId (evt) {
      // disparado a cada mudança do input interno do autocomplete
      this.$emit('retornaId', evt) // pode ser null/ID
    },
    onClear () {
      // quando o usuário clica no "x" do autocomplete
      this.idLocal = null
      this.$emit('retornaId', null)
      this.$emit('retornaNome', null)
      this.$emit('retornaCGC', '')
      // limpa visual
      if (this.$refs.auto) {
        this.$refs.auto.display = ''
        this.$refs.auto.selectedDisplay = ''
        this.$refs.auto.value = null
      }
    },

    clearModal () {
      this.items = []
      this.pesquisa.id = ''
      this.pesquisa.nome = ''
      this.pesquisa.vendedorId = ''
      this.$refs.edNomePesquisa = ''
      //this.$refs.edNomePesquisa && this.$refs.edNomePesquisa.focus()
    },

    selecionar (evt) {
      // seleção dentro da tabela da modal manual
      this.$emit('retornaId', evt.CODIGO)
      this.$emit('retornaNome', evt.CODIGONOME)
      const cgc = Tools.removerMascaraCNPJ(evt.CGC)
      this.$emit('retornaCGC', cgc)
      this.$emit('retornaRAZAO', evt.RAZAOSOCIAL)
      this.$emit('retornaNOME', evt.NOME)

      // atualiza display do autocomplete
      if (this.$refs.auto) {
        this.$refs.auto.display = evt.CODIGONOME
        this.$refs.auto.selectedDisplay = evt.CODIGONOME
        this.$refs.auto.value = evt.ID || evt.CODIGO
      }

      this.clearModal()
      this.$refs[this.idModal].hide()
    },

    onSubmit () {
      if (!this.pesquisa.id && !this.pesquisa.nome) {
        alert('Por favor, informe algum texto/valor para pesquisar')
        return
      }

      const idPesquisado = this.pesquisa.id ? `&idPesquisa=${this.pesquisa.id}` : ''
      const nomePesquisado = (this.pesquisa.nome !== '*') ? `&nomePesquisa=${this.pesquisa.nome}` : ''
      const vend = window.localStorage.getItem('vendedorId')
      const vendedorIdPesquisado = vend ? `&vendedorId=${vend}` : ''

      this.isLoading = true
      this.isBusy = true

      let uri = ''
      if (!vend || vend === '' || vend === '100') {
        uri = `/api/protected/cliente/localizar?aux=1${idPesquisado}${nomePesquisado}`
      } else {
        uri = `/api/protected/cliente/localizar?aux=1${idPesquisado}${nomePesquisado}${vendedorIdPesquisado}`
      }

      return this.$http.get(uri).then(({ data }) => {
        this.items = data
        this.isBusy = false
        this.isLoading = false
        this.status = true
        setTimeout(() => { this.status = '' }, 1000)
      }).catch(() => {
        this.items = []
        this.isLoading = false
        this.isBusy = false
        this.status = false
      })
    },

    async atualizaComplete () {
      // quando o pai passa idInicial (edição), carrega o display e emite eventos
      if (!this.idInicial) return
      const uri = `/api/protected/cliente/pesquisaridmin?idPesquisa=${this.idInicial}`
      try {
        const { data } = await this.$http.get(uri)
        if (!data || !data[0]) return
        const c = data[0]
        // atualiza visual do autocomplete
        if (this.$refs.auto) {
          this.$refs.auto.display = c.CODIGONOME
          this.$refs.auto.selectedDisplay = c.CODIGONOME
          this.$refs.auto.value = c.CODIGO
        }
        // emite para o pai preencher a tela
        const cgc = Tools.removerMascaraCNPJ(c.CGC)
        this.$emit('retornaId', c.CODIGO)
        this.$emit('retornaCGC', cgc)
        this.$emit('retornaRAZAO', c.RAZAOSOCIAL)
        this.$emit('retornaNOME', c.NOME)
        this.$emit('retornaNome', c.CODIGONOME)
        
        this.$emit('retornaRegistro', c)  
        // guarda id local
        this.idLocal = c.CODIGO
      } catch (e) {
        // silencia falha (ex.: id não existe mais)
      }
    },

    onSelecionado ({ selectedObject }) {
      // seleção vinda do componente Autocomplete (lista suspensa)
      if (!selectedObject) { this.onClear(); return }
      const id = selectedObject.CODIGO ?? selectedObject.ID
      const display = selectedObject.CODIGONOME
      const cgc = Tools.removerMascaraCNPJ(selectedObject.CGC)

      this.$emit('retornaId', id)
      this.$emit('retornaNome', display)
      this.$emit('retornaCGC', cgc)
      this.$emit('retornaRAZAO', selectedObject.RAZAOSOCIAL)
      this.$emit('retornaNOME', selectedObject.NOME)

      // atualiza display do autocomplete
      if (this.$refs.auto) {
        this.$refs.auto.display = display
        this.$refs.auto.selectedDisplay = display
        this.$refs.auto.value = id
      }
      this.idLocal = id
    },

    atualizaClasse () {
      // reservado (mantido do seu original)
    },

    // ----- helpers UI/relatórios (mantidos do seu original)
    variant (linha) {
      return (linha.dataVencimentoSemMascara < new Date()) ? 'danger' : 'green'
    },
    variantAvatar (value) {
      if (value <= 0) return 'info'
      if (value > 1 && value <= 5) return 'success'
      if (value > 6 && value <= 15) return 'warning'
      if (value > 16 && value <= 100) return 'danger'
      return 'info'
    },
    colorirSituacao (item) { return item.OP_SITUACAO_FINANCEIRO === '0' ? 'success' : 'danger' },
    traduzirSituacao (item) { return item.OP_SITUACAO_FINANCEIRO === '0' ? 'LIBERADO' : 'BLOQUEADO' },
    variantVencimento (value) {
      return (moment(value).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) ? 'font-vermelha' : 'font-azul'
    },
    flag (value) { return 'flag-icon flag-icon-' + value },
    numberToReal (numero) {
      const n = numero.toFixed(2).split('.')
      n[0] = 'R$ ' + n[0].split(/(?=(?:...)*$)/).join('.')
      return n.join(',')
    },

    abrirModalDebitos () {
      if (this.idLocal === null) { this.debitos.tableItems = []; return }
      this.$store.commit('controle/setAguardando', true)
      const uri = this.$http.defaults.baseURL.concat(`api/protected/areceber/listartitulosporcliente?clienteid=${this.idLocal}`)
      this.$http.get(uri).then(({ data }) => {
        this.debitos.tableItems = []
        this.debitos.totalAtrasado = this.debitos.totalEmDias = 0
        data.forEach(r => {
          this.debitos.tableItems.push({
            avatar: { url: '', status: '' },
            cliente: { nome: r.NOME_CLIENTE, novo: true, documento: r.DOCUMENTO, parcela: r.PARCELA, itens: r.ITENS },
            valor: {
              percentual: r.PERCENTUAL.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 }),
              percentualSemMascara: r.PERCENTUAL,
              valorDocumento: this.numberToReal(r.VL_DOC),
              valorAberto: this.numberToReal(r.VALOR_ABERTO),
              valorAbertoSemMascara: r.VALOR_ABERTO,
              dataInicio: new Date(r.DT_DOC).toISOString().substr(0, 10).split('-').reverse().join('/'),
              dataVencimento: new Date(r.DT_VENC).toISOString().substr(0, 10).split('-').reverse().join('/'),
              dataVencimentoSemMascara: new Date(r.DT_VENC),
              classe: this.variantVencimento(r.DT_VENC)
            },
            dias: r.ULT_BAIXA_DIAS == null ? '0' : r.ULT_BAIXA_DIAS
          })
          if (moment(r.DT_VENC).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
            this.debitos.totalAtrasado += r.VALOR_ABERTO
          } else {
            this.debitos.totalEmDias += r.VALOR_ABERTO
          }
        })
        this.$store.commit('controle/setAguardando', false)
        this.$refs['modal-debitos'].show()
      }).catch(() => {
        this.$store.commit('controle/setAguardando', false)
      })
    },

    imprimir () {
      if (this.idLocal === null) { this.debitos.tableItems = []; return }
      this.$store.commit('controle/setAguardando', true)
      const uri = '/api/protected/relatorios/relareceber'
        + `?clienteid=${this.idLocal}`
        + `&lbempresa=${window.localStorage.getItem('nomeempresa')}`
        + '&grupoid='
        + '&dt1=01-01-2000'
        + '&dt2=01-01-2030'
        + `&lbcliente=${this.$refs.auto.selectedDisplay}`
        + '&lbvendedor='
        + '&lbgrupo='
        + `&lbusuario=${window.localStorage.getItem('nomeusuario')}`
        + '&tiporel=S'
        + '&tipoperiodo=V'

      this.$http.get(uri, { responseType: 'arraybuffer' })
        .then(response => {
          this.$root.$bvToast.toast('Relatório gerado com sucesso!!!', {
            title: 'Aviso', autoHideDelay: 4000, variant: 'success', appendToast: true
          })
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
          const janela = window.open(url)
          if (janela) {
            janela.onload = function () {
              setTimeout(() => { janela.document.title = 'Relatório de Contas a Receber' }, 2000)
            }
          }
          this.$store.commit('controle/setAguardando', false)
        })
        .catch(() => {
          this.$root.$bvToast.toast('Ocorreu uma falha ao gerar o relatório!!!', {
            title: 'Aviso', autoHideDelay: 2000, variant: 'danger', appendToast: true
          })
          this.$store.commit('controle/setAguardando', false)
        })
    },

    escutaAlteracaoDeValor (idSelecionado) {
      // disparado pelo @indexChanged do Autocomplete
      this.idLocal = idSelecionado
    }
  },
  watch: {
    idInicial () { this.atualizaComplete() },
    exibirBloqueado (val) { this.exibirBloqueadoLocal = val },
    labelVermelho (val) { this.labelVermelhoLocal = val }
  },
  created () { this.atualizaComplete() }
}
</script>

<style>
.modal-dialog { top: 50px }
.botao { border-radius: 0; border: 2px solid #20a8d8; }
.b-table .my-left-border { border-left: 1px solid #a4b7c1; }
.b-table .my-left-right { border-right: 1px solid #a4b7c1; }
.b-table .my-left-bottom { border-bottom: 1px solid #a4b7c1; }
.texto-vermelho { background-color: red; color: white; }

/* --- PILL GROUP geral (ativa só quando a prop arredondado = true) --- */
.cec-pill-group .cec-pill-append .btn {
  height: 35px !important;          /* mesma vibe do b-form-input */
  min-height: 35px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
}

/* --- PILL do Cliente (ativa só quando a prop arredondado = true) --- */


/* botão do meio (olho) fica reto */
.cec-pill-mid {
  border-radius: 0 !important;
}

/* último botão fecha o pill */
.cec-pill-right {
  border-top-right-radius: 50px !important;
  border-bottom-right-radius: 50px !important;
}

/* o wrapper do autocomplete (a “caixa” que tem a borda) precisa ter a mesma altura */
/* === FECHA O PILL À ESQUERDA (wrapper do autocomplete) === */
.cec-pill-left.autocomplete__box,
.cec-pill-left.autocomplete__boxrequired,
.cec-pill-left.autocomplete__valid {
  border-top-left-radius: 50px !important;
  border-bottom-left-radius: 50px !important;
  height: 35px !important;

  /* importante: garante que o conteúdo respeite a curva */
  overflow: hidden !important;
}


/* quando abre a lista, tira o arredondado de baixo */
.cec-pill-left.autocomplete__searching {
  border-bottom-left-radius: 0 !important;
}

/* Button Variants */
.btn-soft-primary {
  background-color: rgba(32, 168, 216, 0.1);
  color: #20a8d8;
  border: none;
}
.btn-soft-primary:hover {
  background-color: #20a8d8;
  color: white;
}

/* o input de texto dentro do autocomplete */
.autocomplete__inputs input {
  height: 24px !important;            /* 38 - paddings e ícones */
  line-height: 24px !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  background: transparent !important;
}

.cec-pill-left .autocomplete__inputs input {
  border-radius: 0 !important; /* deixa o wrapper controlar a curva */
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

</style>



// WEBPACK FOOTER //
// src/views/pesquisa/ClientePesquisa.vue